module.exports = __webpack_public_path__ + "img/sumguo.74303b9f.png";